import React from 'react';
import { useTranslation } from 'react-i18next';

import { IS_CLIENT, TOPICAL_PATH } from '../../../config/constants';
import Button from '../../Button';

interface RelatedContentMoreButtonProps {
  url?: string;
}

const RelatedContentMoreButton: React.FC<RelatedContentMoreButtonProps> = (props) => {
  const {
    url = TOPICAL_PATH,
  } = props;

  const { t } = useTranslation();

  return (
    <Button
      type="secondary"
      icon="chevron_right"
      onClick={() => {
        if (IS_CLIENT) {
          window.location.replace(url);
        }
      }}
    >
      {t('components.related_content.more')}
    </Button>
  );
};

export default RelatedContentMoreButton;
